module.exports = __webpack_public_path__ + "img/20.dfd5241f.png";